module.exports = __webpack_public_path__ + "img/23.c88aff5d.jpg";